import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseButton, LinkButton } from './BaseButton';

const tertiaryButtonStyle = {
    color: colorSystem.neutral[7],
    '&:hover': {
        background: colorSystem.primary[1],
        color: colorSystem.primary[7],
    },
    '&:active': {
        background: colorSystem.primary[2],
        color: colorSystem.primary[8],
    },
    '&:disabled': {
        color: colorSystem.neutral[5],
    },
};

const TertiaryButtonHost = styled(BaseButton)(tertiaryButtonStyle);
const TertiaryButtonLinkHost = styled(LinkButton)(tertiaryButtonStyle);

export const TertiaryButton = linkable(TertiaryButtonHost, { linkHost: TertiaryButtonLinkHost });
